import { Menu, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import { MenuButton } from 'src/components/atoms/MenuButton';
import { MenuOption } from 'src/components/atoms/MenuOption';
import { useFilterContext } from 'src/contexts/FilterContext';
import { MenuList } from '../../molecules/MenuList';
import { Icon } from 'src/components/atoms/Icon';
import { MenuTriangle } from 'src/components/atoms/MenuTriangle';

const MENU_BUTTON_NAME = 'campaign-group-select';

export const CampaignGroupMenu: React.FC = () => {
  const { campaignGroups, toggleCampaignGroup, toggleAllCampaignGroups } =
    useFilterContext();
  const fontActiveColor = useColorModeValue(
    'text.darkBlue.900',
    'text.dark.highContrast',
  );

  const selectedCount = campaignGroups.filter((g) => g.selected).length;

  return (
    <Menu isLazy>
      {({ isOpen }) => (
        <>
          <MenuButton
            buttonName={MENU_BUTTON_NAME}
            textAlign="left"
            color={fontActiveColor}>
            <Icon iconName="database" width={6} height={6} mr={2} />
            {selectedCount}/{campaignGroups.length}
            <MenuTriangle isOpen={isOpen} />
          </MenuButton>
          <MenuList
            buttonName={MENU_BUTTON_NAME}
            onAllClick={toggleAllCampaignGroups}>
            {campaignGroups.length === 0 ? (
              <MenuOption
                buttonName={MENU_BUTTON_NAME}
                label="No campaign groups"
                value="empty"
                isSelected={false}
                onClick={() => {}}
              />
            ) : (
              campaignGroups.map((group) => (
                <MenuOption
                  buttonName={MENU_BUTTON_NAME}
                  key={group.id}
                  isSelected={group.selected}
                  label={group.groupName}
                  value={group.id}
                  onClick={() => toggleCampaignGroup(group)}
                />
              ))
            )}
          </MenuList>
        </>
      )}
    </Menu>
  );
};
